import {AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {language} from '../../../language/vn';
import {MauVanBanService} from '../../../service/info/service-mauvanban';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import {MauVanBan} from '../../../models/info/mauvanban';
import { ToastrService } from 'ngx-toastr';
import {BsModalService, ModalDirective} from 'ngx-bootstrap/modal';
import {ConfirmDialogComponent} from '../../dialog/confirmdialog.component';
import {environment} from '../../../../environments/environment';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import {MauVanBanFileService} from '../../../service/info/service-mauvanbanfile';
import {UploadFileComponent} from '../../ui/upload/uploadfile.component';
import {NhomMauVanBan} from '../../../models/danhmuc/nhommauvanban';
import {NhomMauVanBanService} from '../../../service/danhmuc/service-nhommauvanban';
import {EditMauVanBanComponent} from './edit.component';
import {CommandUtil} from '../../../global/commandutil';
import {Sessioncommand} from '../../../global/sessioncommand';
import {NavItemService} from '../../../service/staff/service-navitem';
import {RolePermissionService} from '../../../service/security/service-rolepermission';

@Component({
  templateUrl: './mauvanban.component.html',
  encapsulation: ViewEncapsulation.None
})
export class MauVanBanComponent implements OnInit, AfterViewInit {
  @ViewChild('largeModal')
  public largeModal: ModalDirective;
  @ViewChild(UploadFileComponent)
  public uploadFileComponent: UploadFileComponent;
  private moduleName:  string = 'egov.info.mauvanban';
  public language = language;
  public hoSoId:  number;
  public totalItems: number = 0;
  public currentPage: number   = environment.currentPage;
  public maxSize: number = environment.pageMaxRecord;
  public numPages: number = environment.numberPages;
  public configToolbar: Object = environment.configToolbar;
  public frmGroup: FormGroup;
  public isEdit: boolean = false;
  public isRefresh: boolean = false;
  public dataList: MauVanBan[];
  public submitValidate = false;
  public srTenVanBan: string = '';
  public srGhiChu: string = '';
  public srMaLoai: number = 0;
  public editor = ClassicEditor;
  public uploadUrl: String;
  public deleteUrl: String;
  public fileLists: Object[];
  public dataNhomMau: NhomMauVanBan[];
  public permissionView: boolean = false;
  public permissionDetail: boolean = false;
  public permissionAdd: boolean = false;
  public permissionUpdate: boolean = false;
  public permissionDelete: boolean = false;
  public permissionToanQuyen: boolean = false;
  public permissionDownloadFile: boolean = false;
  constructor( public mauVanBanService: MauVanBanService,
               public formBuilder: FormBuilder,
               public toastr: ToastrService,
               public bsModalService: BsModalService,
               public mauVanBanFileService: MauVanBanFileService,
               public nhomMauVanBanService: NhomMauVanBanService,
               public commandUtil: CommandUtil,
               public rolePermissionService: RolePermissionService

  ) {
  }
  ngAfterViewInit() {

  }
  ngOnInit(): void {
    this.rolePermissionService.checkPermissionByModule(Sessioncommand.staffId, this.moduleName
    ).subscribe( x => {
      this.permissionView = x.findIndex(y => y.action === environment.view) !== -1;
      if (this.permissionView)
        this.search();
      else
        this.rolePermissionService.redirectAccesDenied();
      this.permissionAdd = x.findIndex(y => y.action === environment.add) !== -1;
      this.permissionDetail = x.findIndex(y => y.action === environment.detail) !== -1;
      this.permissionUpdate = x.findIndex(y => y.action === environment.update) !== -1;
      this.permissionDelete = x.findIndex(y => y.action === environment.delete) !== -1;
      this.permissionDownloadFile = x.findIndex(y => y.action === environment.download) !== -1;
      this.permissionToanQuyen = x.findIndex(y => y.action === environment.toanquyen) !== -1;
    });


    this.search();
    this.nhomMauVanBanService.getAll().subscribe(dataNhomMau => this.dataNhomMau = dataNhomMau);
    this.uploadUrl= this.mauVanBanFileService.urlUpload;
    this.deleteUrl= this.mauVanBanFileService.urlDelete;
  }

  public showConfirmationModal(id: number): void {
    const modal = this.bsModalService.show(ConfirmDialogComponent);
    (<ConfirmDialogComponent>modal.content).showConfirmationModal(
      language.message,
      language.confirm_delete_question,
      language.yes,
      language.no
    );
    (<ConfirmDialogComponent>modal.content).onClose.subscribe(result => {
      if (result === true) {
        this.deleteItem(id);
      }
    });
  }
  get f() { return this.frmGroup.controls; }
  edit(id: number) {
    const modalEdit = this.bsModalService.show(EditMauVanBanComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<EditMauVanBanComponent>modalEdit.content).edit(
      id
    );
    (<EditMauVanBanComponent>modalEdit.content).onClose.subscribe(result => {
      if (result === true) {
        this.search();

      }
    });

  }
  search()
  {
    this.mauVanBanService.findAllByPaging(this.srTenVanBan, this.srGhiChu, this.srMaLoai, this.currentPage, this.maxSize).subscribe(dataList => this.dataList = dataList);
    this.mauVanBanService.getCountByKeyword(this.srTenVanBan, this.srGhiChu, this.srMaLoai).subscribe(recordCount => this.totalItems = recordCount);
  }

  deleteItem(id: number)
  {
    this.mauVanBanService.delete(id).subscribe({
      next: () => {
        this.toastr.success(language.delete_success_record, language.message);
        this.search();


      },
      error: error => {
        this.toastr.error(language.error, language.message);
      }
    });
  }

  pageChanged(event: any): void {
    this.currentPage = event.page;
    this.search();

  }

}

